import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { type GraphQLLetter, GraphQLLetterDirection } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { RecentActivityItem } from '../recent-activity-item/recent-activity-item.tsx';
import { processLetterIn } from './recent-activity-item-letter.in.logic.ts';
import { processLetterOut } from './recent-activity-item-letter.out.logic.ts';
export enum LetterInStepsEnum {
  LetterSubmitted = 'recentActivity.letter.preparing',
  InTranslation = 'recentActivity.letter.inTranslation',
  Delivered = 'recentActivity.letter.delivered',
}
export type RecentActivityItemLetterProps = {
  letter: GraphQLLetter;
};
export const RecentActivityItemLetter: React.FC<RecentActivityItemLetterProps> = t0 => {
  const $ = _c(11);
  const {
    letter
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["my"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  if (letter.direction === GraphQLLetterDirection.B2S) {
    let t2;
    if ($[1] !== letter || $[2] !== t) {
      t2 = processLetterIn(letter, t);
      $[1] = letter;
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t2) {
      t3 = <RecentActivityItem {...t2} />;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t2;
  if ($[6] !== letter || $[7] !== t) {
    t2 = processLetterOut(letter, t);
    $[6] = letter;
    $[7] = t;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <RecentActivityItem {...t2} />;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};